import React from "react";
import PropTypes from "prop-types";
import { Divider, withStyles } from "@material-ui/core";
import { obterQuantidadePastosCurralEPesoMedio } from "./detalhesRebanhoUtils";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslations } from "adapters/i18n";

export const InformacaoCategoriaAnimal = (props) => {
  const { classes, categoria, pastos, curraisRetiroComLotes } = props;
  const { quantidadeDeCabecas, quantidadeDeCabecasNoCurral, pesoMedio } =
    obterQuantidadePastosCurralEPesoMedio(
      pastos,
      curraisRetiroComLotes,
      categoria,
    );

  const { t } = useTranslations();

  const pesoMedioKg = typeof pesoMedio === "number" ? pesoMedio : pesoMedio.kg;
  const pesoMedioArroba =
    typeof pesoMedio === "number" ? null : pesoMedio.arroba;
  const stringPeso =
    pesoMedioArroba === null || pesoMedioArroba === undefined
      ? `${pesoMedioKg.toFixed(0)} KG`
      : `${pesoMedioKg.toFixed(0)} KG (${pesoMedioArroba.toFixed(2)} @)`;

  return (
    <Box
      id={`categoria${categoria.IdCategoriaAnimal}`}
      key={categoria.IdCategoriaAnimal}
      sx={{ width: "100%", maxWidth: 500 }}
    >
      <Typography variant="subtitle2" className={classes.title} gutterBottom>
        {categoria.Nome}
      </Typography>
      <Typography variant="body2" gutterBottom className={classes.text}>
        {t("statusIndicator:total-animals-in-pastures")}:{" "}
        <b>{quantidadeDeCabecas ? quantidadeDeCabecas : "0"}</b>
      </Typography>

      <Typography variant="body2" gutterBottom className={classes.text}>
        {t("statusIndicator:total-animals-in-corrals")}:{" "}
        <b>{quantidadeDeCabecasNoCurral ? quantidadeDeCabecasNoCurral : "0"}</b>
      </Typography>

      <Typography variant="body2" gutterBottom className={classes.text}>
        {t("statusIndicator:total-animals-in-pastures-and-corrals")}:{" "}
        <b>{quantidadeDeCabecasNoCurral + quantidadeDeCabecas}</b>
      </Typography>
        <Typography
          variant="body2"
          gutterBottom
          className={classes.text}
        >
          {t("statusIndicator:average-visual-weight")}:{" "}
          <b>{`${pesoMedioKg.toFixed(0)} ${t("common:measure.KG")}`}</b>
        </Typography>
        {pesoMedioArroba !== null && pesoMedioArroba !== undefined && (
          <Typography
            variant="body2"
            gutterBottom
            className={classes.text}
          >
            {t("statusIndicator:weight-in-arrobas")}:{" "}
            <b>{`${pesoMedioArroba.toFixed(0)}${t("common:measure.arroba")}`}</b>
          </Typography>
        )}
      <Divider className={classes.divider} />
    </Box>
  );
};

const styles = (theme) => ({
  title: {
    color: theme.palette.primary.main,
    padding: "20px 0",
  },
  text: {
    color: "#757575",
    fontWeight: "normal",
    padding: "5px 0",
  },

  divider: {
    width: "100%",
    marginTop: "20px",
  },
});

InformacaoCategoriaAnimal.propTypes = {
  pastos: PropTypes.array,
  categorias: PropTypes.array,
};

export default withStyles(styles)(InformacaoCategoriaAnimal);
